import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type HelpTooltipProps = {
  content?: React.ReactNode;
  className?: string;
  triggerClassName?: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
};

/**
 * Tooltip padrão com gatilho "?" para explicar KPIs/campos.
 * - Não renderiza nada se `content` estiver vazio.
 * - Acessível via hover e teclado (focus).
 */
export function HelpTooltip({
  content,
  className,
  triggerClassName,
  side = "top",
  align = "center",
}: HelpTooltipProps) {
  if (!content) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Ajuda"
          className={cn(
            "inline-flex h-4 w-4 items-center justify-center rounded-full border border-border/60 bg-muted/30 text-[10px] font-semibold text-muted-foreground",
            "hover:bg-muted/50 hover:text-foreground transition-colors",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
            triggerClassName,
          )}
        >
          ?
        </button>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        className={cn("max-w-[320px] text-xs leading-snug", className)}
      >
        {typeof content === "string" ? <p>{content}</p> : content}
      </TooltipContent>
    </Tooltip>
  );
}
